(function($){
  $(document).ready(function(){

    $('.tile-image-slider').once('sw-tile-image-slider').each(function() {
      const m = new TileImageSlider($(this));
    });

    $('.tile-image-slider').once('sw-tile-image-slider').each(function() {
      const $slider = $(this);
      const slideCount = $slider.find('.swiper-slide').length;

      if (slideCount > 1) {
        const m = new TileImageSlider($slider);
      }
    });

  });
})(jQuery);

class TileImageSlider {

  constructor($w){
    const _this = this;

    this.$w = $w;

    // Main slider
    this.$swiper = this.$w.find('.tile-image-slider__slider');
    this.swiper = new Swiper(this.$swiper.get(0), {
      loop: false,
      slidesPerView: 1,
      speed: 500,
      followFinger: true,
      navigation: {
        nextEl: this.$w.find('.swiper__arrow--right').get(0),
        prevEl: this.$w.find('.swiper__arrow--left').get(0),
      },
      pagination: {
        el: this.$w.find('.swiper__pagination').get(0),
        type: 'bullets',
      },
    });

    this.$w.data('sw-tile-image-slider', this);
  }

}
